'use strict';

import * as THREE from "three";
import {detectMobile, getUrlParam} from "./functions";
import {ViewMode} from "./common";
import gsap from "gsap";
import {checkTabletMode} from "./app";
import { District } from './modules/building/District';

const MobileDetect = require('mobile-detect');

// export const isMobile = detectMobile();
export const isMobile = Boolean(new MobileDetect(window.navigator.userAgent).mobile() && !new MobileDetect(window.navigator.userAgent).tablet());
export const isTablet = Boolean(new MobileDetect(window.navigator.userAgent).mobile() && new MobileDetect(window.navigator.userAgent).tablet())
    || /Macintosh/.test(window.navigator.userAgent) && 'ontouchend' in document;
export const isSafari = /Safari/.test(navigator.userAgent) && (!(/CriOS/.test(navigator.userAgent)) && !(/Chrome/.test(navigator.userAgent)));

if (isMobile && !isTablet) document.body.classList.add('mobile-mode');

export const isDev = getUrlParam('dev') === 'true';

export const threeJsVariables = {
    scene: {},
    raycaster: {},
    animator: null,
    mouse: new THREE.Vector2(),
    perspectiveCamera: {},
    cameraTarget: {},
    renderer: {},
    stats: null,
    labelRenderer: {},
    tooltipRenderer: null,
    tilesRenderer: null,
    directionLightCylinder: null,
    composer: null,
    time: null,
    gui: null
}

export const settingsData = {
    loadingError: false,
    flyIsComplete: false,
    slideShowed: false,
    isSound: false,
    projectLoaded: false,
    postProcessing: { //Post-Processing settings
        isActive: false,
        effectFXAA: false,
        depthOfFields: false,
        depthOfFields2: false,
        ambientOcclusion: false,
    },
    stopTimeRender: 5 * 60 * 1000, //time after which the render will stop 5 minutes
    desktopGallery:{
        columnCount: 3,
        gutter: 10
    },
    activeViewMode: ViewMode.Orbit,
    calculatePoints: false,
    widgetsPaddingTop: 72,
    destroyedMode: false,
    selectedObject: null,
    hoveredObject: null,
    bombBlock: false,
    userPrevent: false,
    animationsList:[],
    searchState: [],
    dictionary: null,
    tourOrbitMode: false,
    zoomButtonsStep: {
        increase: 0.02,
        decrease: -0.02
    },
    globalSettings: {
        doubleClickToUnavailable: false,
        flat_focus: false,
        totalDollyBounce: 1,
        // destroyedBuilding: {
        //     cameraPosition: {
        //         zoom: 60,
        //         mobile_zoom: 85,
        //     },
        //     cameraLimits: {
        //         rotation: {
        //             children_x: {
        //                 min: -1.57,
        //                 max: -0.5
        //             }
        //         }
        //     }
        // },
        // fullBuilding: {
        //     cameraLimits: {
        //         rotation: {
        //             children_x: {
        //                 min: -0.95,
        //                 max: -0.2
        //             }
        //         }
        //     }
        // },
        // exposure: {
        //     dictionary: {
        //         North: 'North',
        //         West: 'West',
        //         East: 'East',
        //         South: 'South',
        //     }
        // },

        floorAppearAnimation: {
            durationBase: 700,
            addPosition: 1000,
            axis: 'y',
        }
    },
    showApplyNow: true,
    lastClickedFlat: '',
    stopRender: false,
    target_zoom: '',
    isIntersection: false,
    buildingDestroyed: false,
    last_interaction: Date.now(),
    totalPercent: 0,
    customSelections: [],
    instanced_floors: [],
    instanced_floors_switch: {},
    currentFloor: 0,
    floor_obj: {},
    lastHoverObject: '',
    objectToDisappear: [],
    isSwitched: false,
    tween_animations: {},
    current_mouse_position: {x : 0, y : 0},
    box_to_intersection: [],
    objects_to_intersection: [],
    additionalIntersectionObjects: [],
    poiIntersection: [],
    floor_plan_btn_last_click: Date.now(),
    headerObjectState:{
        lastSize: 0,
        lastSizeWhenMobileMenuActivated: 0,
    },
    doubleClick: false,
    sceneBgContent:{
        orbit:{},
        cylinder:{}
    },
    // isLandscape: window.innerWidth <= 926 && window.innerHeight <= 450,
    isLandscape: window.matchMedia("(orientation: landscape)").matches,
    // isTabletPortrait: checkTabletMode(),
    switchLang: false,
    isDesktopMode: !isMobile && getUrlParam('desktop'),
    isConferenceHost: window.location.host.match(/conferencedreams.bmby.com/gi) || window.location.host.match(/conferencedreams2.bmby.com/gi) || window.location.host.match(/dreams360.bmby.com/gi) || window.location.host.match(/dreams360lite.bmby.com/gi),
    //isConferenceHost: true,
    isFlat: false,
    tl: gsap.timeline(),
    isTouchEvent: false,
    isClickEvent: false,
    stopWindowResizeEvents: false,
    totalTilesCount: 0,
    customCursor: false,
    animateBuildingHover: false,
    activeModeSwitching: false,
    statisticData: {}
};

export const Buildings = new District();

export const cardsData = {
    cardMode: {
        isUnavailable: false,
        isAmenities: false
    },
    openedCards: [],
    multiplyCards: false,
};


export const projectMode = {
    Orbit: null,
    Cylinder: null,
    FloorPlan: null,
    LiteMode: null,
    Pagination: null
};

export const globalTextures = {};

// window.bi = buildings_info;
window.b = Buildings;
window.v = threeJsVariables;
window.s = settingsData;
window.c = config;
window.ct = threeJsVariables.cameraTarget;
window.cd = cardsData;
window.pm = projectMode;
window.gt = globalTextures;
